import { Includes } from '@/types/common.type'

export interface ConfigurationRelationshipsState<Option extends object, Relationship extends object & Includes<Relationship, Option>> {
    option: Option
}
export const initialConfigurationRelationshipsState =
    (): ConfigurationRelationshipsState<any, any> => ({
        option: null
    })
